import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCalendarCustomEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-calendar-custom-embed',
	path: '/jira/core/projects/:projectKey/calendar/:itemId/embed',
	exact: true,
};
